import { render, staticRenderFns } from "./SaleInfoNormal.vue?vue&type=template&id=46b71290&scoped=true&"
import script from "./SaleInfoNormal.vue?vue&type=script&lang=js&"
export * from "./SaleInfoNormal.vue?vue&type=script&lang=js&"
import style0 from "./SaleInfoNormal.vue?vue&type=style&index=0&id=46b71290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b71290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b71290')) {
      api.createRecord('46b71290', component.options)
    } else {
      api.reload('46b71290', component.options)
    }
    module.hot.accept("./SaleInfoNormal.vue?vue&type=template&id=46b71290&scoped=true&", function () {
      api.rerender('46b71290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/publishGoods/components/SaleInfoNormal.vue"
export default component.exports